import React from 'react';
import { IconBox, IconProps } from 'src/lib/IconBox';

const PlusIcon = (props: IconProps) => (
  <IconBox {...props}>
    <path
      clipRule="evenodd"
      fillRule="evenodd"
      d="M36.0005 4c0-2.20914-1.7909-4-4-4-2.2092 0-4 1.79086-4 4v23.9999H4c-2.20914 0-4 1.7908-4 4 0 2.2091 1.79086 4 4 4h24.0005V60c0 2.2091 1.7908 4 4 4 2.2091 0 4-1.7909 4-4V35.9999H60c2.2091 0 4-1.7909 4-4 0-2.2092-1.7909-4-4-4H36.0005V4z"
    />
  </IconBox>
);

export default PlusIcon;
